/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Entity_ClientInputs */

const cs_import_entity_client = /** @type {(inputs: Import_Entity_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienti`)
};

const en_import_entity_client = /** @type {(inputs: Import_Entity_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients`)
};

/**
* | output |
* | --- |
* | "Clients" |
*
* @param {Import_Entity_ClientInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_entity_client = /** @type {((inputs?: Import_Entity_ClientInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Entity_ClientInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_entity_client(inputs)
	return cs_import_entity_client(inputs)
});